module.exports = __webpack_public_path__ + "assets/img/need.c6df8c9f.png";